var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaladecine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H4.25C3.91848 12 3.60053 11.8736 3.36612 11.6486C3.1317 11.4235 3 11.1182 3 10.8V4.2C3 3.88174 3.1317 3.57651 3.36612 3.35147C3.60053 3.12643 3.91848 3 4.25 3H8",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H19.7273C20.0648 3 20.3886 3.12643 20.6273 3.35147C20.8659 3.57651 21 3.88174 21 4.2V10.8C21 11.1182 20.8659 11.4235 20.6273 11.6486C20.3886 11.8736 20.0648 12 19.7273 12H14",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5V11L15 8L10 5Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21V18.7778C3 18.041 3.31607 17.3345 3.87868 16.8136C4.44129 16.2927 5.20435 16 6 16C6.79565 16 7.55871 16.2927 8.12132 16.8136C8.68393 17.3345 9 18.041 9 18.7778V21",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21V18.7778C9 18.041 9.31607 17.3345 9.87868 16.8136C10.4413 16.2927 11.2043 16 12 16C12.7957 16 13.5587 16.2927 14.1214 16.8136C14.6839 17.3345 15 18.041 15 18.7778V21",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21V18.7778C15 18.041 15.3161 17.3345 15.8786 16.8136C16.4413 16.2927 17.2043 16 18 16C18.7957 16 19.5587 16.2927 20.1214 16.8136C20.6839 17.3345 21 18.041 21 18.7778V21",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaladecine);
export default __webpack_public_path__ + "static/media/Sala de cine.922a091a4b80f08df9f6a3761146a9f3.svg";
export { ForwardRef as ReactComponent };